export default {
      id: "flag-us-usage",
      viewBox: "0 0 36 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#flag-us",
      toString: function () {
        return this.url;
      }
    }